var defaultConfigs = {
  device: 'mobile | desktop',
  ui: {
    layout: 'full'
  },
  formType: 'minimal',
  stepInvoke: false,
  regexValidation: true,
  mandatoryCountries: [''],
  hiddenCountries: [''],
  authorization: {
    apiKey: '',
    cheggBaseUrl: 'https://www.chegg.com'
  },
  appConstants: {
    cdnUrl: 'https://c.cheggcdn.com/assets/',
    flagUrl: 'https://c.cheggcdn.com/assets/site/flag-icons/'
  },
  debug: {
    allowInvalidZipcodes: false
  }
};
export { defaultConfigs };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/business/configManager/types.js
// module id = 4501
// module chunks = 11